import { useState, useContext, useEffect } from 'react';
import { FolderOutlined, FolderOpenOutlined, PlusOutlined, CaretDownOutlined } from '@ant-design/icons';
import { Button, Tabs, Tree } from 'antd';
import { MaterialManageContext } from '../hooks/MaterialManageContext';
import styles from './index.module.scss';

// 菜单数据（后续从接口获取）
const TREE_DATA = [
    {
        title: '参考图管理',
        key: 'refImage',
        count: 124,
        children: [
            { title: '全部参考图', key: 'refImage_all', count: 124, isLeaf: true },
            { title: '试衣参考图', key: 'refImage_tryon', count: 124, isLeaf: true },
            { title: '姿势裂变参考图', key: 'refImage_pose', count: 124, isLeaf: true },
            { title: '鞋子上脚参考图', key: 'refImage_shoes', count: 124, isLeaf: true },
            { title: '眼镜试戴参考图', key: 'refImage_glasses', count: 124, isLeaf: true },
            { title: '背景参考图', key: 'refImage_bg', count: 124, isLeaf: true },
        ]
    },
    {
        title: '户外参考图',
        key: 'outdoor',
        count: 124,
        isLeaf: true,
    },
    {
        title: '2025图片整理',
        key: 'album2025',
        count: 124,
        isLeaf: true,
    },
    {
        title: '模特图管理',
        key: 'templateManage',
        disabled: true,
        tag: '敬请期待',
        isLeaf: true,
    },
    {
        title: '参考视频管理',
        key: 'videoManage',
        disabled: true,
        tag: '敬请期待',
        isLeaf: true,
    }
];

const Sidebar = () => {
    const { activeMenu, setActiveMenu, setActiveMenuName } = useContext(MaterialManageContext);
    const [expandedKeys, setExpandedKeys] = useState(['refImage']); // 默认展开参考图管理

    // 默认选中全部参考图
    useEffect(() => {
        if (!activeMenu) {
            setActiveMenu('refImage_all');
            setActiveMenuName('全部参考图');
        }
    }, [activeMenu, setActiveMenu, setActiveMenuName]);

    const handleExpand = (newExpandedKeys) => {
        setExpandedKeys(newExpandedKeys);
    };

    const handleSelect = (selectedKeys, info) => {
        if (selectedKeys.length > 0) {
            const node = info.node;
            if (!node.disabled) {
                setActiveMenu(node.key);
                setActiveMenuName(node.title);
            }
        }
    };

    const handleNodeToggle = (nodeData, e) => {
        e.stopPropagation();
        if (nodeData.disabled) return;
        const isExpanded = expandedKeys.includes(nodeData.key);
        const newKeys = isExpanded
            ? expandedKeys.filter(k => k !== nodeData.key)
            : [...expandedKeys, nodeData.key];
        handleExpand(newKeys);
    };

    const titleRender = (nodeData) => {
        const isActive = activeMenu === nodeData.key;
        const isDisabled = nodeData.disabled;
        const isExpanded = expandedKeys.includes(nodeData.key);
        const hasChildren = nodeData.children && nodeData.children.length > 0;
        
        let icon = hasChildren && isExpanded ? <FolderOpenOutlined /> : <FolderOutlined />;
        
        return (
            <div className={`${styles.treeNodeContent} ${isActive ? styles.activeNode : ''} ${isDisabled ? styles.disabledNode : ''}`}>
                {hasChildren ? (
                    <span 
                        className={`${styles.customSwitcher} ${isExpanded ? styles.expanded : ''}`} 
                        onClick={(e) => handleNodeToggle(nodeData, e)}
                    >
                        <CaretDownOutlined />
                    </span>
                ) : (
                    <span className={styles.switcherPlaceholder} />
                )}
                <span className={styles.nodeIcon}>{icon}</span>
                <span className={styles.nodeTitle}>{nodeData.title}</span>
                {nodeData.tag ? (
                    <span className={styles.nodeTag}>{nodeData.tag}</span>
                ) : (
                    <span className={styles.nodeCount}>{nodeData.count}</span>
                )}
            </div>
        );
    };

    return (
        <div className={styles.Sidebar}>
            {/* 顶部 Tab 切换 */}
            <div className={styles.tabHeader}>
                <Tabs 
                    defaultActiveKey="personal" 
                    items={[
                        { key: 'personal', label: '个人素材' },
                        { key: 'enterprise', label: '企业素材' }
                    ]}
                />
            </div>

            {/* 菜单列表 */}
            <div className={`${styles.menuList} _beauty_scrollbar`}>
                <Tree
                    treeData={TREE_DATA}
                    expandedKeys={expandedKeys}
                    onExpand={handleExpand}
                    selectedKeys={[activeMenu]}
                    onSelect={handleSelect}
                    titleRender={titleRender}
                    blockNode
                    showIcon={false}
                    switcherIcon={null}
                    className={styles.customTree}
                />
            </div>

            {/* 新建文件夹按钮 */}
            <div className={styles.createFolderBtnWrap}>
                <Button type="primary" icon={<PlusOutlined />} className={styles.createBtn}>
                    新建文件夹
                </Button>
            </div>
        </div>
    );
};

export default Sidebar;